import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import MobileMenuModule from './app';
import './styles.scss';
export default class MobileMenu{
	constructor(config,route,$module){
		let el = $module[0];

		const props = {
			navigation: config,
			route: route
		}
		ReactDOM.render(React.createElement(MobileMenuModule,props),el);
	}
}

MobileMenu.init = (config,route,$module) => {
	$module = $module || $('[data-module="MobileMenu"]');
	if($module.length>0) {
		new MobileMenu(config,route,$module);
	}
}



// WEBPACK FOOTER //
// ./src/app/mobile-menu/index.js